import { useParams } from "react-router-dom";

import { Button, Card, CircularProgress } from "@mui/material";
import { Form, Formik } from "formik";

import { Translate } from "@/components/Application/Translate";

import { AlertRequest } from "@/helpers/alerts/AlertRequest";
import CustomDropZoneUpload from "@/helpers/components/CustomFormFields/CustomDropZoneUpload";

import { UploadProcedureNodeDocumentRequest } from "@/model/Procedure/ProcedureNodeDependency";

import { UploadProcedureNodeDocument } from "@/service/ProcedureMutations";
import { useFetchDocumentForCurrentNode } from "@/service/ProcedureQueries";
import { RouteParams } from "@/service/Utilities";

type Props = {
	onClose: () => void;
	nodeId: number;
	isUploading: boolean;
};

const NodeDocumentUpload = (props: Props) => {
	const { id: ProcedureId } = useParams<RouteParams>();
	const { onClose, nodeId } = props;
	const { isLoading, data } = useFetchDocumentForCurrentNode({
		ProcedureId: +ProcedureId,
		SchemeId: nodeId,
	});
	const uploadProcedureNodeDocument = UploadProcedureNodeDocument();

	const handleSave = async (values: UploadProcedureNodeDocumentRequest) => {
		values.FileName = values.File?.name;
		values.ExternalUniqueId = "";
		try {
			await uploadProcedureNodeDocument(values);
			AlertRequest.success();
			onClose();
		} catch (error) {
			AlertRequest.failed();
		}
	};

	return (
		<Formik
			initialValues={{
				ProcedureId: +ProcedureId,
				SchemeId: nodeId,
				File: data?.Document,
				FileName: data?.Document?.FileName,
				ExternalUniqueId: data?.Document?.ExternalUniqueId,
			}}
			onSubmit={handleSave}
			// TODO: Make validation
		>
			{({ values, setFieldValue, isSubmitting }) => (
				<Form style={{ marginBottom: 0 }}>
					<Card
						elevation={2}
						style={{
							padding: "1rem",
							textAlign: "center",
							height: "300px",
						}}
					>
						<CustomDropZoneUpload
							name="File"
							translationString="File.Dropzone"
							id={"File"}
							type="file"
							setFieldValue={setFieldValue}
						/>
					</Card>
					<Button
						variant="outlined"
						color="success"
						sx={{ margin: "1rem", position: "fixed", top: 50, right: 100 }}
						type="submit"
						disabled={isSubmitting || isLoading || props.isUploading}
						startIcon={
							isSubmitting || isLoading || props.isUploading ? (
								<CircularProgress size={20} />
							) : null
						}
					>
						<Translate String="Procedure.Button.Save">Save</Translate>
					</Button>
				</Form>
			)}
		</Formik>
	);
};

export default NodeDocumentUpload;
